import { useState } from 'react';
import { useForm, ValidationError } from '@formspree/react';

interface ContactProps {
  isQuestion: boolean;
}

function Contact({ isQuestion }: ContactProps) {
  const [state, handleSubmit] = useForm("xpzvnpze");
  const [email,setEmail] = useState('');
  const [nameUser,setNameUser] = useState('');
  const [organization, setOrganization] = useState('')
  const [inn, setInn] = useState('');
  const [theme,setTheme] = useState('');
  const [message, setMessage] = useState('');
  const [goodsName, setGoodsName] = useState('');
  const [goodsAmount, setGoodsAmount] = useState('');
  
  if (state.succeeded) {
      return <p>Thanks for joining!</p>;
  }

  return (
      <form 
      action="https://formspree.io/f/xpzvnpze"
      method="POST"
      onSubmit={handleSubmit}>
      {/* <ValidationError 
        prefix="Email" 
        field="email"
        errors={state.errors}
      /> */}
      <div className='flex flex-col gap-4'>
        <label htmlFor="nameUser" className="block text-sm font-medium text-gray-700">
          <p className='pb-[2px]'>ФИО<span style={{ color: 'red' }}>*</span></p>
          <input
            type="text"
            className="border-1 ring-1 ring-gray-300 rounded-lg text-sm px-4 py-2 w-full focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              required
            id="nameUser"
            placeholder="Иван Иванов Иванович"
            name="nameUser"
            value={nameUser}
            onChange={(event) => setNameUser(event.target.value)}
          />
         </label>
         <label htmlFor="email" className="block text-sm font-medium text-gray-700">
          <p className='pb-[2px]'>Email<span style={{ color: 'red' }}>*</span></p>
          <input
            type="email"
            placeholder="mail@mail.com"
            className="border-1 ring-1 ring-gray-300 rounded-lg text-sm px-4 py-2 w-full focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
            required
            id="email"
            name="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)} // Исправленный обработчик onChange
          />
        </label>
        <label htmlFor="organization" className="block text-sm font-medium text-gray-700">
          <p className='pb-[2px]'>Организация</p>
          <input
            type="text"
            placeholder="ООО 'Организация'"
            className="border-1 ring-1 ring-gray-300 rounded-lg text-sm px-4 py-2 w-full focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
            id="organization"
            name="organization"
            value={organization}
            onChange={(event)=>{setOrganization(event.target.value)}}
          />
        </label>
        <label htmlFor="inn" className="block text-sm font-medium text-gray-700">
        <p className='pb-[2px]'>ИНН</p>
          <input
            type="text"
            placeholder="123123123"
            className="border-1 ring-1 ring-gray-300 rounded-lg text-sm px-4 py-2 w-full focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
            id="inn"
            name="inn"
            value={inn}
            onChange={(event)=>{setInn(event.target.value)}}
          />
        </label>
        <label htmlFor="theme" className="block text-sm font-medium text-gray-700">
          <p className='pb-[2px]'>Тема<span style={{ color: 'red' }}>*</span></p>
          <input
          type="text"
          placeholder="Сообщение в тех. поддержку"
          className="border-1 ring-1 ring-gray-300 rounded-lg text-sm px-4 py-2 w-full focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
          required
          id="theme"
          name="theme"
          value={theme}
          onChange={(event)=>{setTheme(event.target.value)}}
        />

        </label>
        {!isQuestion && (
        <div className='flex gap-4'>
          <label htmlFor="goodsName" className="block text-sm font-medium text-gray-700">
            <p className='pb-[2px]'>Товар или услуга<span style={{ color: 'red' }}>*</span></p>
            <input
              type="text"
              placeholder="Название товара"
              className="border-1 ring-1 ring-gray-300 rounded-lg text-sm px-4 py-2 w-full focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              required
              id="goodsName"
              name="goodsName"
              value={goodsName}
              onChange={(event)=>{setGoodsName(event.target.value)}}
            />
          </label>
         
          <div className='flex gap-4'>
            <label htmlFor="goodsAmount" className="block text-sm font-medium text-gray-700">
              <p className='pb-[2px]'>Кол-во<span style={{ color: 'red' }}>*</span></p>
              <input
                type="text"
                placeholder="Кол-во"
                className="border-1 ring-1 ring-gray-300 rounded-lg text-sm px-4 py-2 w-full focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                required
                id="goodsAmount"
                name="goodsAmount"
                value={goodsAmount}
                onChange={(event)=>{setGoodsAmount(event.target.value)}}
              />
            </label>
            <p className='flex items-end'>шт.</p>
          </div>
        </div>
 )}
        <textarea 
        placeholder="Сообщение"
        id="message"
        name="message"
        className="border-1 ring-1 min-h-[110px] ring-gray-300 rounded-lg text-sm px-4 py-2 w-full focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
        value={message}
        onChange={(event)=>setMessage(event.target.value)}
        >

        </textarea>

        <div className='flex flex-row-reverse '>
          <button type="submit" disabled={state.submitting} className='bg-[#304DB6] text-white rounded-md text-base max-h-10 hover:scale-110 transition duration-2000 transform text-center flex items-center justify-center w-[156px]'>
            <p className='px-[50px] py-2'>Отправить</p>
          </button> 
        </div>
      </div>
    </form>
  );
}
export default Contact;